export const environment = {
  production: true,
  // backend: "https://api.marefix.sdi.es/api",
  // login: "https://api.marefix.sdi.es",
  // assets: "https://api.marefix.sdi.es/img/",
  backend: "https://api.marefix.com/api",
  login: "https://api.marefix.com",
  assets: "https://api.marefix.com/img/",
};
